"use client";

import React from "react";

import Logo from "@/components/molecules/logo-component/logo";
import Styles from "@/components/molecules/policy-document-section/policy-document-section.module.css";

interface WithdrawalBannerContentProps {
  withdrawalBannerTitle: string;
  withdrawalBannerDescription: string;
}

function WithdrawalBannerContent({
  withdrawalBannerTitle,
  withdrawalBannerDescription,
}: Readonly<WithdrawalBannerContentProps>) {
  return (
    <div
      className="flex flex-col lg:mb-[78px]"
      data-testid="withdrawal-banner-content-testid"
    >
      <div className="flex flex-col gap-spacing-m">
        <Logo
          color="white"
          size="xl"
          className={`!p-0 m-0 hidden lg:block ${Styles.logo}`}
          isWithdrwal
        />
        <h1 className="font-header-font text-[23px] md:text-[39px] leading-[27.6px] md:leading-[45px] text-left text-dark-text-title lg:py-0">
          {withdrawalBannerTitle ?? ""}
        </h1>
      </div>
      <div className="text-xs leading-[27px] text-left text-dark-text-title lg:py-0">
        {withdrawalBannerDescription ?? ""}
      </div>
    </div>
  );
}

export default WithdrawalBannerContent;
